import PropTypes from 'prop-types';
import React from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { bitacoraApi } from 'src/api/modules/bitacora';
import CustomButton from 'src/common/components/CustomButton';

const ExportXLSX = ({
	data = [],
	columns = [],
	fileName = '',
	label = 'Descargar Excel',
	className = '',
	disabled = false,
}) => {
	const getHeaders = () =>
		columns
			.filter((col) => col.text !== 'Acciones')
			.map((col) => ({ label: col.text, key: col.dataField }));

	const getData = () => {
		const headers = getHeaders();
		return data.map((item) => {
			const row = {};
			headers.forEach(({ key }) => {
				if (Array.isArray(item[key])) {
					row[key] = item[key].map((el) => el.nombre).join(', ');
				} else {
					row[key] = item[key] || '';
				}
			});
			return row;
		});
	};

	const exportToExcel = () => {
		const headers = getHeaders();
		const dataToExport = getData();


		const worksheet = XLSX.utils.json_to_sheet(dataToExport, {
			header: headers.map((h) => h.key),
		});
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');


		const excelBuffer = XLSX.write(workbook, {
			bookType: 'xlsx',
			type: 'array',
		});
		const blob = new Blob([excelBuffer], {
			type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		});

		saveAs(blob, fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`);


		bitacoraApi.post({
			accion: 'Descargó Excel ' + fileName,
		});
	};

	return (
		<CustomButton
			className={className}
			disabled={disabled}
			color="info"
			onClick={exportToExcel}
			mainText={label}
		/>
	);
};

ExportXLSX.propTypes = {
	columns: PropTypes.array.isRequired,
	data: PropTypes.array.isRequired,
	fileName: PropTypes.string.isRequired,
	label: PropTypes.string,
	className: PropTypes.string,
	disabled: PropTypes.bool,
};

export default ExportXLSX;
